import { SourceDataInitials } from '@/constants/SourceDataInitials';
import { GridColumnType } from '@/constants/GridColumnType';

export default interface GridHeaderCellData {
    type: GridColumnType;
    initials: SourceDataInitials;
    name: string;
    title: string;
    subCompIdx?: number | null;
}

/**
 * Create a new instance with default values.
 * @returns
 */
export function newGridHeaderCellData(): GridHeaderCellData {
    const cellData: GridHeaderCellData = {
        type: GridColumnType.Unknown,
        initials: SourceDataInitials.None,
        name: '',
        title: ''
    };
    return cellData;
}
